import React from "react";
import {
  MenuHeaderContainer,
  MenuTitleText,
  MenuChildrenContainer,
  MenuHeaderFeatures,
} from "./styles";
import type { TypeMenuHeaderProps } from "./MenuHeaderTypes";

/**
 * @link https://seeds.sproutsocial.com/components/seeds-react-menu/#menuheader
 *
 * @description MenuHeader is a container used to hold header content within a Menu.
 *
 * @see {@link https://seeds.sproutsocial.com/components/seeds-react-menu/#menufooter MenuFooter}
 * @see {@link https://seeds.sproutsocial.com/components/seeds-react-menu/#menusearchinput MenuSearchInput}
 * @see {@link https://seeds.sproutsocial.com/components/seeds-react-menu/#menusearchtokeninput MenuSearchTokenInput}
 */

const MenuHeader = ({
  children,
  title,
  leftAction,
  rightAction,
  ...rest
}: TypeMenuHeaderProps) => {
  const showTopRow = title || leftAction || rightAction;
  return (
    <>
      <MenuHeaderContainer $leftAction={!!leftAction} {...rest}>
        {showTopRow && (
          <MenuHeaderFeatures $leftAction={!!leftAction}>
            {leftAction && leftAction}
            {title && (
              <MenuTitleText $leftAction={!!leftAction}>{title}</MenuTitleText>
            )}

            {rightAction && <div className="right-action">{rightAction}</div>}
          </MenuHeaderFeatures>
        )}

        {children && <MenuChildrenContainer>{children}</MenuChildrenContainer>}
      </MenuHeaderContainer>
    </>
  );
};

export { MenuHeader };
